import React from 'react';

const Button = ({
  children,
  onClick,
  variant = 'primary',
  size = 'md',
  disabled = false,
  className = ''
}) => {
  const variants = {
    primary: 'bg-button-1 text-global-6 hover:opacity-90',
    secondary: 'bg-button-2 text-global-6 hover:opacity-90',
    tertiary: 'bg-button-3 text-button-1 hover:opacity-90'
  };

  const sizes = {
    sm: 'px-3 py-1 text-sm',
    md: 'px-4 py-2',
    lg: 'px-5 py-3 text-lg'
  };

  return (
    <button
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      className={`tw-rounded-lg tw-font-inter tw-font-semibold tw-transition-opacity tw-border-none ${variants[variant]} ${sizes[size]} ${disabled ? 'tw-opacity-50 tw-cursor-not-allowed' : ''
        } ${className}`}
    >
      {children}
    </button>

  );
};

export default Button;